import { getElement, getElements } from '../utils/functional'

export default class {
  constructor (el) {
    this.els = {
      el,
      backdrop: getElement('.drw-Drawer_Backdrop', { context: el }),
      bodyClass: getElement('.bdy-Body'),
      triggersAll: getElements('[data-module-drawers-trigger]')
    }
    this.drawers = getElements('[data-module-drawers-drawer]').map(el => {
      const key = el.getAttribute('data-module-drawers-drawer')

      return {
        key,
        drawer: el,
        trigger: getElements(`[data-module-drawers-trigger="${key}"]`),
        close: getElements(`[data-module-drawers-close="${key}"]`)
      }
    })
    this.classes = {
      activeBackdropClass: 'drw-Drawer_Backdrop-active',
      activeDrawerClass: 'drw-Drawer-active'
    }
    this._activeDrawerKey = ''

    this.setupListeners()
  }

  setupListeners () {
    this.els.backdrop.addEventListener('click', () => {
      this.activeDrawerKey = ''
      this.els.triggersAll.forEach(trigg => {
        trigg.classList.remove('hd-Mobile_Item-active')
      })
    })
    this.els.el.addEventListener('click', ({ target }) => {
      if (target.classList.contains('drawer-close')) {
        this.activeDrawerKey = ''
      }
    })

    this.drawers.forEach(drawer => {
      const { key, trigger, close } = drawer

      if (trigger) {
        trigger.forEach(trigg => {
          trigg.addEventListener('click', event => {
            this.els.triggersAll.forEach(trigg2 => {
              trigg === trigg2
                ? trigg2.classList.toggle('hd-Mobile_Item-active')
                : trigg2.classList.remove('hd-Mobile_Item-active')
            })

            event.preventDefault()
            this.activeDrawerKey = key === this.activeDrawerKey ? '' : key
          })
        })
      }

      if (close) {
        close.forEach(cls => {
          cls.addEventListener('click', event => {
            trigger.forEach(trig => {
              trig.classList.remove('hd-Mobile_Item-active')
            })
            event.preventDefault()
            this.activeDrawerKey = ''
          })
        })
      }
    })
  }

  get activeDrawerKey () {
    return this._activeDrawerKey
  }

  set activeDrawerKey (val) {
    this._activeDrawerKey = val

    const somethingIsActive = val !== ''

    this.drawers.forEach(drawer => {
      drawer.drawer.classList.toggle(
        this.classes.activeDrawerClass,
        val === drawer.key
      )
    })
    this.els.backdrop.classList.toggle(
      this.classes.activeBackdropClass,
      somethingIsActive
    )
    this.els.bodyClass.classList.toggle(this.classes.activeDrawerClass)
  }
}
